module.exports = __webpack_public_path__ + "img/barn.fbb5edc2.svg";